export default {
  Main: () => '/',
  ProductList: () => 'sort',
  MarketProductList: () => 'sort',
  Cart: () => 'cart',
  MyInfo: () => 'personal',
  Goodsdetail: (query) => `product/${query.product_id}`,
  ShopIndex: (query) => `shop/${query.shop_id}`,
  Livebroadcast: (query) => `shop/${query.shop_id}`,
  Classification: (query) => `shop/goods/${query.shop_id}`,
  AppDownload: () => 'download',
  AppDownloadBuyer: () => 'download',
  Market: () => 'market',
  MarketDetail: (query) => `market/detail?id=${query.id}&name=${query.name}&zone=${query.zone}`,
  FinancialInsurance: () => 'industrialFinance',
  InternationalCountry: () => 'international/index',
  ArticleList_list: (query) =>
    query.id ? `articleList/list?type=${query.type}&id=${query.id}&type_id=${query.type_id}` : '',
  LeaderboardLivelist: () => 'livePrefecture?name=直播',
  LeaderboardShoplist: 'leaderboard/shoplist',
  LeaderboardProductlist: 'leaderboard/shoplist',
  special: (query) => `activies/special?code=${query.active_code || query.code}`,
  ActiviesChildren: (query) => `activies/children?code=${query.active_code || query.code}`,
  seckill: () => `limitedTimeActivities`
}
